import { useEffect } from 'react'
import I18n from 'translations/i18n'
import {
  benefitTypesLoad,
  vacationSalaryCalculationLoad,
  vacationSalaryCalculationUpdate,
} from 'redux/organizationOnborading/VacationSalary/actionCreators'

import { Widget } from '@jisr-hr/design-system'
import { useSelector, useDispatch } from 'utils/hooks'
// import WidgetWithDrawer from 'containers/authorised/setting/v2/components/WidgetWithDrawer';
import { organizationInfo } from 'redux/organizationOnborading/organization/actionCreators'
import SwitchAttendanceReflection from './SwitchAttendanceReflection'

const CalcualtionOfVacationSalary = (): JSX.Element => {
  const dispatch = useDispatch()
  const { fetching, vacation_salary_calculation } = useSelector(
    ({ VacationSalary }) => VacationSalary,
  )

  const handleOnRadioChange = (value: number, key: string): void => {
    const hitApi = {
      vacation_salary: () => vacationSalaryCalculationUpdate({ value }),
    }
    if (value !== 3) {
      dispatch(hitApi[key]()).then(() => dispatch(organizationInfo()))
    }
  }

  useEffect(() => {
    dispatch(benefitTypesLoad())
    dispatch(vacationSalaryCalculationLoad())
  }, [])
  return (
    <div>
      <Widget
        title={I18n.t('calculation_of_vacation_salary')}
        fetching={fetching}
      >
        <SwitchAttendanceReflection
          title="vacation_salary"
          active
          configurationValue={vacation_salary_calculation?.value}
          handleOnRadioChange={handleOnRadioChange}
          benefit_type_ids={vacation_salary_calculation?.benefit_type_ids}
        />
      </Widget>
    </div>
  )
}

export default CalcualtionOfVacationSalary
